// Mock data for Moonshine Solutions GmbH website

export const SITE = {
  brand: 'Moonshine Solutions',
  brandFull: 'Moonshine Solutions GmbH',
  tagline: 'Deine Zukunft. Dein Vermögen.',
  ceo: 'Pascal Schwab',
  email: 'kontakt@pascalschwab.com',
  social: {
    facebook: 'https://www.facebook.com/profile.php?id=61556725782230',
    instagram: 'https://www.instagram.com/pascals.solutions/',
    linkedin: 'https://www.linkedin.com/in/pascal-schwab-55293b264/',
    mail: 'mailto:kontakt@pascalschwab.com',
  },
  vorsorgecheckUrl: 'https://finanzcheck.moonshine-solutions.com/',
  vorsorgegeldUrl: 'https://vorsorgegeld-finden-leichtgemacht.ch/link/sU4B4G',
  karriereUrl: 'https://tally.so/r/3jpLV1',
  alphalaneUrl: 'https://alphalane-tradingsystems.com',
  trustpilotUrl: 'https://ch.trustpilot.com/review/moonshine-solutions.com',
};

export const IMAGES = {
  logo: '/logo-moonshine.png',
  logoMark: '/logo-mark.png',
  pascal: '/photos/pascal-sitting.jpg',
  pascalDesk: '/photos/pascal-sitting.jpg',
  pascalProfile: '/photos/pascal-leaning.jpg',
  pascalCrypto: '/photos/pascal-leaning.jpg',
  pascalVorsorge: '/photos/pascal-sitting.jpg',
  pascalEdelmetalle: '/photos/pascal-leaning.jpg',
  hero: '/photos/pascal-hero.jpg',
  immobilien: 'https://images.unsplash.com/photo-1624204386084-dd8c05e32226?auto=format&fit=crop&w=1600&q=85',
  krypto: 'https://images.unsplash.com/photo-1621264448270-9ef00e88a935?auto=format&fit=crop&w=1600&q=85',
  alphalane: 'https://images.unsplash.com/photo-1621264448270-9ef00e88a935?auto=format&fit=crop&w=1600&q=85',
  vorsorge: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1600&q=85',
  edelmetalle: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?auto=format&fit=crop&w=1600&q=85',
  vorsorgeCard: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1200&q=85',
  immobilienCard: 'https://images.unsplash.com/photo-1624204386084-dd8c05e32226?auto=format&fit=crop&w=1200&q=85',
  kryptoCard: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1200&q=85',
  alphalaneCard: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1200&q=85',
  edelmetalleCard: 'https://images.unsplash.com/photo-1610375461369-d613b564f4c4?auto=format&fit=crop&w=1200&q=85',
  goldAbstract: 'https://images.unsplash.com/photo-1761437855598-011cf89b2ad4?auto=format&fit=crop&w=1600&q=85',
  values1: 'https://pascalschwab.weebly.com/uploads/1/4/9/1/149102869/wert-11_orig.png',
  values2: 'https://pascalschwab.weebly.com/uploads/1/4/9/1/149102869/2_orig.png',
  values3: 'https://pascalschwab.weebly.com/uploads/1/4/9/1/149102869/3_orig.png',
  values4: 'https://pascalschwab.weebly.com/uploads/1/4/9/1/149102869/4_orig.png',
  values5: 'https://pascalschwab.weebly.com/uploads/1/4/9/1/149102869/5_orig.png',
  testimonial1: 'https://pascalschwab.weebly.com/uploads/1/4/9/1/149102869/published/client-testimonials-instagram-post.png?1713167971',
  testimonial2: 'https://pascalschwab.weebly.com/uploads/1/4/9/1/149102869/editor/noooah.png?1713167905',
  testimonial3: 'https://pascalschwab.weebly.com/uploads/1/4/9/1/149102869/editor/client-testimonials-instagram-post-2.png?1711460046',
  careerBg: 'https://images.unsplash.com/39/lIZrwvbeRuuzqOoWJUEn_Photoaday_CSD%20%281%20of%201%29-5.jpg?auto=format&fit=crop&w=1600&q=85',
};

export const SERVICES = [
  {
    id: 'vorsorge',
    title: 'Verlorenes Vorsorgegeld finden',
    short: 'Vorsorgegeld',
    image: IMAGES.vorsorgeCard,
    excerpt: 'Auf Freizügigkeitskonten liegen rund 16 Milliarden Schweizer Franken ungenutzt. Finde in wenigen Klicks heraus, ob auch Du 2. Säulen Gelder verloren hast.',
    href: '/vorsorge',
  },
  {
    id: 'immobilien',
    title: 'Immobilien als Kapitalanlage',
    short: 'Immobilien',
    image: IMAGES.immobilienCard,
    excerpt: 'Ein strukturierter Sparplan eröffnet Dir die Möglichkeit, ohne Eigenkapitaleinsatz Immobilien als Kapitalanlage zu erwerben und monatliche Mieteinnahmen zu generieren.',
    href: '/immobilien',
  },
  {
    id: 'alphalane',
    title: 'Alphalane AI Trading',
    short: 'Alphalane AI',
    image: IMAGES.alphalaneCard,
    excerpt: 'Profitiere von den Märkten – ohne selbst zu traden. KI-gesteuertes, vollautomatisches Trading aus der Schweiz. 24/5 aktiv, transparenter Track Record, ab 2’000 USD.',
    href: '/alphalane',
  },
  {
    id: 'edelmetalle',
    title: 'Vermögensaufbau mit Edelmetallen',
    short: 'Edelmetalle',
    image: IMAGES.edelmetalleCard,
    excerpt: 'Warum Geld sparen, wenn täglich mehr davon gedruckt wird? Investiere lieber in inflationsgeschützte und limitierte Güter wie Gold, Silber und andere Edelmetalle.',
    href: '/edelmetalle',
  },
];

export const SUPPORT_PILLARS = [
  {
    title: 'Businesspartner',
    text: 'Als unabhängiger Partner stehen wir Privatpersonen und Unternehmen zur Seite, um individuelle und nachhaltige Lösungen zu entwickeln, die langfristigen Erfolg sichern.',
  },
  {
    title: 'Karrierechance',
    text: 'Ergreife die Gelegenheit, deine Karriere auf das nächste Level zu bringen, indem du mit uns gemeinsam neue Wege gehst.',
  },
  {
    title: 'Vermögensaufbau',
    text: 'Durch exklusive und einzigartige Konzepte zum Kapitalaufbau präsentieren wir dir innovative Wege, um deine finanziellen Ziele sicher und langfristig zu erreichen.',
  },
];

export const VALUES = [
  { title: 'Vertrauen', text: 'Transparente, ehrliche Beratung als Fundament jeder Zusammenarbeit.' },
  { title: 'Kompetenz', text: 'Langjährige Erfahrung & fundiertes Wissen in allen Anlageklassen.' },
  { title: 'Motivation', text: 'Führung durch Vorbild und gemeinsame Vision von Erfolg.' },
  { title: 'Nachhaltigkeit', text: 'Langfristig wirksame Strategien statt kurzfristiger Gewinne.' },
  { title: 'Wachstum', text: 'Kontinuierliche Weiterbildung & Anpassung an neue Märkte.' },
];

export const TESTIMONIALS = [
  {
    name: 'Noah K.',
    role: 'Kunde · Vermögensaufbau',
    rating: 5,
    text: 'Pascal hat mir die Augen geöffnet. Endlich verstehe ich meine Finanzen und habe einen klaren Plan. Die Beratung war von Anfang an ehrlich, kompetent und auf meine Situation zugeschnitten.',
  },
  {
    name: 'Sandra M.',
    role: 'Kundin · Immobilien',
    rating: 5,
    text: 'Dank des strukturierten Sparplans konnte ich meine erste Anlageimmobilie kaufen – ohne Eigenkapital. Pascal begleitet mich seit dem ersten Tag und ist immer erreichbar.',
  },
  {
    name: 'Marco B.',
    role: 'Kunde · Alphalane AI',
    rating: 5,
    text: 'Das Alphalane AI Trading-System ist absolute Spitze. Strukturiert, transparent, datengetrieben – und die Resultate sprechen für sich. Klare Empfehlung für jeden, der ernsthaft am Markt partizipieren will.',
  },
  {
    name: 'Lara F.',
    role: 'Kundin · Vorsorge',
    rating: 5,
    text: 'Über das Vorsorge-Tool habe ich tatsächlich Geld wiedergefunden, von dem ich gar nichts mehr wusste. Pascal hat mir geholfen, das Kapital sinnvoll anzulegen. Sehr empfehlenswert!',
  },
  {
    name: 'Daniel R.',
    role: 'Kunde · Edelmetalle',
    rating: 5,
    text: 'Ich wollte mein Vermögen vor Inflation schützen und habe genau die richtige Beratung erhalten. Pascal nimmt sich Zeit, erklärt alles verständlich und drängt zu nichts. Top!',
  },
  {
    name: 'Selina H.',
    role: 'Kundin · Vermögensaufbau',
    rating: 5,
    text: 'Endlich jemand, der nicht einfach Produkte verkaufen will. Pascal hat sich Zeit genommen, meine Situation zu verstehen, und mir einen ganzheitlichen Plan erstellt. Sehr professionell und sympathisch.',
  },
];

export const INTEREST_OPTIONS = ['Immobilien', 'Alphalane AI', 'Edelmetalle', 'Vorsorge', 'Vermögensaufbau allgemein', 'Nebenberuflich durchstarten'];
export const REACHABILITY_OPTIONS = ['Werktags', 'Am Wochenende', 'Tagsüber', 'Am Abend'];

